import(/* webpackMode: "eager" */ "/home/vsts/work/1/s/src/features/auth-page/login.tsx")